import { useRouter } from 'next/router';
import * as React from 'react';
import { API } from 'src/api';
import { CalendarView } from 'src/features/calendar';
import { GanttView } from 'src/features/gantt';
import { Board, useKanbanStore } from 'src/features/kanban';
import { ListGridView } from 'src/features/list';
import { useTableStore } from 'src/features/list/store';
import { Timesheet } from 'src/features/timesheet';

import { useBoardStore } from '../store/useBoardStore';
import { Analytics } from './Analytics';

const { useEffect } = React;

export const BoardView = ({ type, id }: { type: string; id: string }) => {
  const boardsStore = useBoardStore();
  const { setColumns, setLabels } = useTableStore((s) => ({
    setColumns: s.setColumns,
    setLabels: s.setLabels,
  }));

  const router = useRouter();
  const orgId = router?.query?.orgId;
  const mode = router?.query?.mode;

  useEffect(() => {
    useKanbanStore.setState({
      columns: boardsStore.columns,
      type: 'boards',
      boardId: boardsStore.id,
      labels: boardsStore.labels,
      onSearchUsers: handleSearchUsers,
    });
  }, [boardsStore.columns]);

  useEffect(() => {
    useKanbanStore.setState({
      labels: boardsStore.labels,
    });
  }, [boardsStore.labels]);

  useEffect(() => {
    if (type === 'list') {
      if (boardsStore.columns.length > 0) {
        setColumns(boardsStore.columns, boardsStore.fields);
        setLabels(boardsStore.labels);
      }
    }
  }, [type, boardsStore.columns]);

  useEffect(() => {
    if (!['list', 'gantt', 'calendar', 'timesheet', 'analytics', 'kanban'].includes(type)) {
      router.replace({
        pathname: `/${mode}/${orgId}/files/${router.query.slug}`,
        query: router.query.taskId
          ? {
              taskId: router.query.taskId,
            }
          : undefined,
      });
    }
  }, [type]);

  return (
    <div>
      {type === 'list' ? (
        <ListGridView id={id} />
      ) : type === 'gantt' ? (
        <GanttView />
      ) : type === 'calendar' ? (
        <CalendarView />
      ) : type === 'timesheet' ? (
        <Timesheet />
      ) : type === 'analytics' ? (
        <Analytics />
      ) : type === 'kanban' ? (
        <Board />
      ) : (
        <></>
      )}
    </div>
  );
};

const handleSearchUsers = async (search) => {
  try {
    const response = await API.get(`user/member?name=${search}`);
    if (response.data.success) {
      return response.data?.data?.map((obj) => ({
        id: obj.memberId,
        display: obj.firstname,
        email: obj.email,
        role: obj.role,
        avatar: obj.avatar,
      }));
    }
  } catch (error) {
    console.error(error);
  }
  return [];
};
